var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import React, { useEffect, useRef, useState } from 'react';
import { useSelector } from 'react-redux';
import { c, notifications } from '@debbie/cortex/dist';
import * as updatesLib from '@debbie/cortex/dist/api/updates';
import { selectUpdateTypeGroups } from '@debbie/cortex/dist/update-type-groups/selectors';
import { selectUpdateTypes, selectUpdateTypesMap, } from '@debbie/cortex/dist/update-types/selectors';
import { selectWorkflows } from '@debbie/cortex/dist/workflows/selectors';
import { ExternalLink, X, Zap } from './Icons';
import { Panel, Input, Button, Checkbox, SearchInput, Select, FileDropzone, File, Modal, Well, } from './index';
import Loading from './Loading';
import WYSIWYGEditor from './WYSIWYGEditor';
import { Section, SectionContentPanel } from './PanelSection';
import Procedure from './Workflows/Procedure';
import ProcedureCreator from './Workflows/ProcedureCreator';
import THEME from '../theme';
const UpdateTypeSettings = (props) => {
    const id = props.updateTypeId;
    const dropzoneRef = useRef(null);
    const lang = useSelector((s) => s.lang);
    const [loading, setLoading] = useState(false);
    const [deleting, setDeleting] = useState(false);
    const [label, setLabel] = useState(null);
    const [heroTextEditModalOpen, setHeroTextEditModalOpen] = useState(false);
    const updateTypes = useSelector(selectUpdateTypes);
    const updateTypesMap = useSelector(selectUpdateTypesMap);
    const updateTypeGroups = useSelector(selectUpdateTypeGroups);
    const workflows = useSelector(selectWorkflows);
    const updateType = updateTypes &&
        updateTypes.find((updateType) => updateType.updateTypeId === id);
    const editable = !(updateType === null || updateType === void 0 ? void 0 : updateType.public);
    useEffect(() => {
        if (!updateTypeGroups) {
            c.updateTypeGroups.get();
        }
    }, []);
    useEffect(() => {
        if (!workflows) {
            c.workflows.getAll();
        }
    }, []);
    const save = (change) => __awaiter(void 0, void 0, void 0, function* () {
        if (updateType) {
            setLoading(true);
            try {
                yield updatesLib.patchType(updateType.updateTypeId, change);
                yield c.updates.types();
                notifications.notification({
                    title: `${lang.inputs.saved}!`,
                });
            }
            catch (error) {
                console.error(error);
                alert('Error');
            }
            setLoading(false);
        }
    });
    const pauseWithUpdateOnCaseExit = updateTypesMap &&
        updateType &&
        updateType.pauseWithUpdateOnCaseExit &&
        updateTypesMap[updateType.pauseWithUpdateOnCaseExit];
    const updateTypeGroup = updateTypeGroups &&
        updateType &&
        updateType.groupId &&
        updateTypeGroups.find((group) => group.groupId === updateType.groupId);
    const getLabel = () => {
        return label === null ? updateType && updateType.label : label;
    };
    const inWorkflows = workflows &&
        workflows.filter((workflow) => workflow.tasks.find((task) => task.updateTypeId === id));
    return (React.createElement(React.Fragment, null,
        React.createElement(Panel, { header: React.createElement("div", null,
                lang.updatesEditor.update,
                ' ',
                loading && (React.createElement(Loading, { style: {
                        float: 'right',
                        cursor: 'pointer',
                    }, width: "20px" }))) },
            inWorkflows && !!inWorkflows.length && (React.createElement(Section, { header: lang.updatesEditor.information, description: lang.updatesEditor.informationDescription },
                React.createElement("ul", null, inWorkflows.map((workflow) => (React.createElement("li", { key: workflow.workflowId, style: {
                        cursor: 'pointer',
                    }, onClick: () => c.redirect.redirect(`/workflows/${workflow.workflowId}`) },
                    workflow.title,
                    ' ',
                    React.createElement(ExternalLink, { style: {
                            margin: '0.1em 0 -0.1em',
                        } }))))))),
            React.createElement(Section, { header: lang.updatesEditor.standardSettings, description: lang.updatesEditor.standardSettingsDescription }, updateType && (React.createElement("div", null,
                React.createElement(SectionContentPanel, null,
                    React.createElement("h3", null, lang.updatesEditor.label),
                    React.createElement(Input, { value: getLabel() || '', onChange: (e) => setLabel(e.target.value), placeholder: "Label", autofocus: true, disabled: !editable, onKeyDown: (e) => {
                            if (e.key === 'Enter' &&
                                updateType &&
                                getLabel() !== updateType.label) {
                                save({ label: getLabel() || '' });
                            }
                        }, button: updateType && getLabel() !== updateType.label
                            ? {
                                value: lang.updatesEditor.save,
                                onClick: () => save({ label: getLabel() || '' }),
                            }
                            : undefined })),
                React.createElement(SectionContentPanel, null,
                    React.createElement("h3", null, lang.updatesEditor.updateTypeGroup),
                    React.createElement(SearchInput, { onSelect: (groupId) => {
                            save({
                                groupId,
                            });
                        }, disabled: !editable, static: updateTypeGroup && updateTypeGroup.label, onRemoveStatic: () => {
                            save({
                                groupId: null,
                            });
                        }, searchDelay: 0, forceOpen: true, searchAll: (q) => ((updateTypeGroups &&
                            updateTypeGroups.filter((_updateTypeGroup) => !q ||
                                JSON.stringify(_updateTypeGroup)
                                    .toLocaleLowerCase()
                                    .indexOf(q.toLocaleLowerCase()) !== -1)) ||
                            []).map((_updateTypeGroup) => ({
                            heading: _updateTypeGroup.label,
                            subheading: _updateTypeGroup.short,
                            key: _updateTypeGroup.groupId,
                            returnData: _updateTypeGroup.groupId,
                        })), placeholder: lang.updatesEditor.selectUpdateTypeGroup })),
                React.createElement(SectionContentPanel, null,
                    React.createElement("h3", null, lang.updatesEditor.important),
                    React.createElement(Checkbox, { checked: updateType.important, placeholder: lang.updatesEditor.importantPlaceholder, disabled: !editable, onChange: (e) => save({
                            important: e.target.checked,
                            importantTheme: e.target.checked ? 'WARNING' : null,
                        }) })),
                React.createElement(SectionContentPanel, null,
                    React.createElement("h3", null, lang.updatesEditor.pausing),
                    React.createElement(Checkbox, { checked: updateType.pausing, placeholder: lang.updatesEditor.pausingPlaceholder, disabled: !editable, onChange: (e) => save({
                            pausing: e.target.checked,
                        }) })),
                React.createElement(SectionContentPanel, null,
                    React.createElement("h3", null, lang.updatesEditor.selectable),
                    React.createElement(Checkbox, { checked: updateType.selectable, placeholder: lang.updatesEditor.selectablePlaceholder, disabled: !editable, onChange: (e) => save({
                            selectable: e.target.checked,
                        }) }))))),
            ((updateType === null || updateType === void 0 ? void 0 : updateType.procedureEnabled) || editable) && (React.createElement(Section, { header: lang.updatesEditor.procedure, description: lang.updatesEditor.procedureDescription }, updateType && (React.createElement(SectionContentPanel, null,
                React.createElement("h3", null,
                    lang.updatesEditor.procedureOn,
                    ' ',
                    updateType.procedureEnabled && (React.createElement("span", { style: {
                            color: THEME.COLOR_ACCENT,
                        } },
                        React.createElement(Zap, { style: {
                                float: 'right',
                            } })))),
                updateType.procedure && (React.createElement(Procedure, { procedure: updateType.procedure, onChange: (procedure) => {
                        const toProcedureEnabled = !!(procedure && procedure.length > 0);
                        let procedureEnabled;
                        if (toProcedureEnabled !== updateType.procedureEnabled) {
                            procedureEnabled = toProcedureEnabled;
                        }
                        save({
                            procedure: procedure,
                            procedureEnabled,
                        });
                    } })),
                React.createElement("br", null),
                editable && (React.createElement(ProcedureCreator, { onCreate: (todos) => {
                        let procedureEnabled;
                        if (!updateType.procedureEnabled) {
                            procedureEnabled = true;
                        }
                        save({
                            procedure: (updateType.procedure || []).concat(todos),
                            procedureEnabled,
                        });
                    } })),
                React.createElement("br", null))))),
            React.createElement(Section, { header: lang.updatesEditor.onCaseExit, description: lang.updatesEditor.onCaseExitDescription }, updateType && (React.createElement(React.Fragment, null,
                React.createElement(SectionContentPanel, null,
                    React.createElement("h3", null, lang.updatesEditor.onCaseExitPauseWith),
                    React.createElement(SearchInput, { onSelect: (updateTypeId) => {
                            save({
                                pauseWithUpdateOnCaseExit: updateTypeId,
                            });
                        }, disabled: !editable, static: (() => {
                            return pauseWithUpdateOnCaseExit
                                ? lang.updateTypes[pauseWithUpdateOnCaseExit.updateTypeId] || pauseWithUpdateOnCaseExit.label
                                : '';
                        })(), onRemoveStatic: () => {
                            save({
                                pauseWithUpdateOnCaseExit: null,
                            });
                        }, searchDelay: 0, forceOpen: true, searchAll: (q) => ((updateTypes &&
                            updateTypes.filter((_updateType) => !q ||
                                JSON.stringify(_updateType)
                                    .toLocaleLowerCase()
                                    .indexOf(q.toLocaleLowerCase()) !== -1)) ||
                            []).map((_updateType) => ({
                            heading: lang.updateTypes[_updateType.updateTypeId] ||
                                _updateType.label,
                            key: _updateType.updateTypeId,
                            returnData: _updateType.updateTypeId,
                        })), placeholder: lang.updatesEditor.selectUpdateType })),
                React.createElement(SectionContentPanel, null,
                    React.createElement("h3", null, lang.updatesEditor.onCaseExitContinueUpdates),
                    React.createElement(Checkbox, { checked: updateType.continueOnCaseExit, placeholder: lang.updatesEditor.continueOnCaseExit, disabled: !editable, onChange: (e) => save({
                            continueOnCaseExit: e.target.checked,
                        }) }))))),
            React.createElement(Section, { header: lang.updatesEditor.roles, description: lang.updatesEditor.rolesDescription }, updateType && (React.createElement("div", null,
                React.createElement(SectionContentPanel, null,
                    React.createElement("h3", null, lang.updatesEditor.responsibleRole),
                    React.createElement(Select, { value: updateType && updateType.responsiblePermissionLevel, onChange: (e) => __awaiter(void 0, void 0, void 0, function* () {
                            save({
                                responsiblePermissionLevel: e.target.value,
                            });
                        }), disabled: !editable }, ['client', 'caseworker', 'admin'].map((role) => (React.createElement("option", { key: role, value: role }, lang.roles[role]))))),
                React.createElement(SectionContentPanel, null,
                    React.createElement("h3", null, lang.updatesEditor.hiddenForCreditors),
                    React.createElement(Checkbox, { checked: !!(updateType &&
                            updateType.hiddenPermissionLevel === 'client'), onChange: (e) => __awaiter(void 0, void 0, void 0, function* () {
                            save({
                                hiddenPermissionLevel: e.target.checked ? 'client' : null,
                            });
                        }), disabled: !editable, placeholder: lang.updatesEditor.hiddenForCreditorsPlaceholder }))))),
            (editable ||
                updateType.introductionHTML ||
                updateType.introductionHeroFile) && (React.createElement(Section, { header: lang.updatesEditor.introduction, description: lang.updatesEditor.introductionDescription }, updateType && (React.createElement("div", null,
                React.createElement(SectionContentPanel, null,
                    React.createElement("h3", null, lang.updatesEditor.introductionHeaderImage),
                    React.createElement(FileDropzone, { onChange: (file) => {
                            if (editable) {
                                save({
                                    introductionHeroFile: file,
                                });
                            }
                        }, dropzoneRef: dropzoneRef, style: {
                            padding: '40px',
                            margin: '20px 0',
                            border: '2px dashed lightgrey',
                        } }, updateType.introductionHeroFile ? (React.createElement(File, { file: updateType.introductionHeroFile, onRemove: () => save({
                            introductionHeroFile: null,
                        }), removable: true })) : (React.createElement("p", { style: { textAlign: 'center' } }, lang.updatesEditor.introductionHeaderImageDropText))),
                    updateType.introductionHTML && (React.createElement(React.Fragment, null,
                        React.createElement(Well, null,
                            React.createElement(X, { style: { float: 'right', cursor: 'pointer' }, onClick: () => save({
                                    introductionHTML: null,
                                }) }),
                            React.createElement("div", { dangerouslySetInnerHTML: {
                                    __html: updateType.introductionHTML,
                                } })),
                        React.createElement("br", null))),
                    React.createElement(Button, { theme: "secondary", onClick: () => setHeroTextEditModalOpen(true), disabled: !editable }, "Redig\u00E9r tekst"),
                    heroTextEditModalOpen && (React.createElement(Modal, { header: ' ', onToggle: () => setHeroTextEditModalOpen(!heroTextEditModalOpen) },
                        React.createElement(WYSIWYGEditor, { onChange: (html) => {
                                save({
                                    introductionHTML: html,
                                });
                                setHeroTextEditModalOpen(false);
                            }, html: updateType.introductionHTML }))),
                    React.createElement("br", null),
                    React.createElement("br", null))))))),
        !props.preventDelete && (React.createElement(Button, { size: "small", theme: "dangerous", loading: deleting, onClick: () => __awaiter(void 0, void 0, void 0, function* () {
                if (inWorkflows && inWorkflows.length > 0) {
                    alert('Cannot delete this update because it is being used in a workflow.');
                    return;
                }
                if (updateType) {
                    if (confirm(lang.updatesEditor.deleteWarning)) {
                        setDeleting(true);
                        try {
                            yield updatesLib.delType(updateType.updateTypeId);
                            yield c.updates.types();
                            c.redirect.redirect('/settings/workflows/tasks');
                        }
                        catch (error) {
                            console.error(error);
                            alert('Error');
                        }
                        setDeleting(false);
                    }
                }
            }) }, lang.updatesEditor.deleteButton))));
};
export default UpdateTypeSettings;
//# sourceMappingURL=UpdateTypeSettings.js.map